import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "account-chip" };
const _hoisted_2 = ["src"];
const _hoisted_3 = { class: "account-chip-name" };
const _hoisted_4 = {
    key: 0,
    class: "account-chip-num"
};
const _hoisted_5 = { class: "summary-row" };
const _hoisted_6 = { class: "summary-left" };
const _hoisted_7 = { class: "summary-amount" };
const _hoisted_8 = { class: "summary-sub" };
const _hoisted_9 = { class: "summary-right" };
const _hoisted_10 = { class: "summary-count" };
const _hoisted_11 = { class: "summary-sub" };
const _hoisted_12 = { class: "merchant-pill" };
const _hoisted_13 = ["src"];
const _hoisted_14 = { class: "merchant-pill-text" };
import { computed, ref, watch } from 'vue';
import { getBrandLogoUrl } from '@/utils/helpers';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TransactionGroupCard',
    props: {
        account: {},
        merchant: {},
        amount: {},
        date: {},
        rawDate: {},
        count: {},
        formatter: {},
        selected: { type: Boolean },
        transactionId: {},
        description: {},
        hasKnownMerchant: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const maskedAccount = computed(() => {
            const n = props.account?.accountNumber;
            return n ? '****' + String(n).slice(-4) : '';
        });
        const merchantLogo = computed(() => getBrandLogoUrl(props.merchant));
        const showMerchantLogo = ref(!!props.hasKnownMerchant);
        watch(() => [props.merchant, props.hasKnownMerchant], () => {
            showMerchantLogo.value = !!props.hasKnownMerchant;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(['card', { selected: _ctx.selected, 'stack-2': _ctx.count === 2, 'stack-3': _ctx.count >= 3 }]),
                style: _normalizeStyle('--card-bg: #' + (_ctx.account.bank.hexColour2 ? _ctx.account.bank.hexColour2.substring(2) : '281C3B'))
            }, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "card-sheen" }, null, -1)),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("img", {
                        class: "account-chip-logo",
                        src: _ctx.account.bank.logoPath ? require('@/assets/logos/' + _ctx.account.bank.logoPath) : _ctx.account.bank.logoUri,
                        alt: ""
                    }, null, 8, _hoisted_2),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.account.displayName), 1),
                    (maskedAccount.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(maskedAccount.value), 1))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "summary-label" }, "Total", -1)),
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.formatter.format(Math.abs(_ctx.amount))), 1),
                        _createElementVNode("div", _hoisted_8, "Latest: " + _toDisplayString(_ctx.date), 1)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.count), 1),
                        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.count === 1 ? 'transaction' : 'transactions'), 1)
                    ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                    (showMerchantLogo.value)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "merchant-pill-logo",
                            src: merchantLogo.value,
                            onError: _cache[0] || (_cache[0] = ($event) => (showMerchantLogo.value = false)),
                            alt: ""
                        }, null, 40, _hoisted_13))
                        : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_14, _toDisplayString((_ctx.description || _ctx.merchant).toUpperCase()), 1)
                ])
            ], 6));
        };
    }
});
